import { createSlice } from "@reduxjs/toolkit";
import { CreateAppData } from "../types/CreateAppType";
import { createDueDiligenceAction } from "../action/createDueDiligenceAction";

const initialState: CreateAppData = {
  data: null,
  loading: false,
  error: null,
};

const createDueDiligenceSlice = createSlice({
  name: "dueDiligenceDetails",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createDueDiligenceAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createDueDiligenceAction.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(createDueDiligenceAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const createDueDiligenceReducer = createDueDiligenceSlice.reducer;
